import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatLabel } from '@angular/material/input';
import { MatTooltip } from '@angular/material/tooltip';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-kyloe-call-settings',
  imports: [
    FormsModule,
    MatLabel,
    ReactiveFormsModule,
    MatLabel,
    MatTooltip,
    MatIcon,
    MatIconButton
  ],
  templateUrl: './kyloe-call-settings.component.html',
  styleUrl: '../call-integration-settings.scss',
})
export class KyloeCallSettingsComponent {
  @Input()
  form: FormGroup;

  @Output()
  domainAdded = new EventEmitter<void>();

  @Output()
  domainRemoved = new EventEmitter<number>();

  inviteAddress: string = environment.ntInviteDomain;

  constructor(private fb: FormBuilder) {}

  get domainsArray(): FormArray {
    return this.form.get('domains') as FormArray;
  }

  addDomain(): void {
    this.domainAdded.emit();
  }

  removeDomain(index: number): void {
    this.domainRemoved.emit(index);
  }
}
